import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppHttpService } from './app.httpservices';
import { LoginModel } from '../Models/Login';
import { User } from '../Models/User';
import { AppSessionStorage } from './app.sessionstorage';
import { JwtHelperService } from '@auth0/angular-jwt';



@Injectable()
export class AppAuthenticationService {

    public User: User;
    private helper = new JwtHelperService();
    private isUserAuthenticated = new BehaviorSubject<boolean>(false);
    public isAdmin = new BehaviorSubject<boolean>(false);
    public lastUpdated = new BehaviorSubject<Date>(new Date());

    constructor(private httpService: AppHttpService, private sessionStorage: AppSessionStorage) {
        this.User = new User();
    }

    validateToken() {
        return this.httpService.post('api/validatetoken', '');
    }

    isUserAdmin(): boolean {
        return this.isAdmin.getValue();
    }

    isAuthenticated(): boolean {
        this.isUserAuthenticated.next(this.getToken() != null && this.getToken().length > 0);
        return this.isUserAuthenticated.getValue();
    }

    getToken() {
        return this.sessionStorage.getSession('ut');
    }

    logOn(loginUser: LoginModel) {
       return this.httpService.post<string>('api/validateuser', loginUser);
    }

    populateToken(token: string) {
        const decodedToken = this.helper.decodeToken(token);
        this.User.firstName = decodedToken.FirstName;
        this.User.lastName = decodedToken.LastName;
        this.User.realtorLicense = decodedToken.RealtorLicense;
        this.User.userName = decodedToken.UserName;
        this.User.userId = decodedToken.UserId;
        if (decodedToken.Aa === 'true') {
             this.isAdmin.next(true);
        }
        if (decodedToken.LastUpdated) {

            this.lastUpdated.next(decodedToken.LastUpdated);
        }
        this.sessionStorage.setSession('ut', token);
    }

    clearToken() {
        this.sessionStorage.setSession('ut', '');
        this.isAdmin.next(false);
        this.isUserAuthenticated.next(false);
    }
}


